let base = {
  "/": require("@/views/Main.vue")
};

let log = {
  "/logs/LogsOper": require("@/module/logs/LogsOper.vue"),
  "/logs/LogsServ": require("@/module/logs/LogsServ.vue"),
  "/logs/LogsSign": require("@/module/logs/LogsSign.vue"),
  "/logs/LogsTask": require("@/module/logs/LogsTask.vue"),
  "/logs/LogsNotice": require("@/module/logs/LogsNotice.vue"),
};

let usrm = {
  "/sysm/UserMgr": require("@/module/usrm/UserMgr.vue"),
  "/sysm/RoleMgr": require("@/module/usrm/RoleMgr.vue"),
  "/sysm/OrgMgr": require("@/module/usrm/OrgMgr.vue"),
  "/sysm/PermMgr": require("@/module/usrm/PermMgr.vue"),
  "/sysm/FileMgr": require("@/plugin/Uploader.vue")
};

let sysm = {
  "/sysm/CodeMgr": require("@/module/sysm/CodeMgr.vue"),
  "/sysm/ParaMgr": require("@/module/sysm/ParaMgr.vue"),
  "/sysm/TaskMgr": require("@/module/sysm/TaskMgr.vue"),
  "/sysm/Notice": require("@/module/sysm/Notice.vue"),
  "/sysm/Query": require("@/module/sysm/SysQueryView.vue"),
  "/sysm/QueryMgr": require("@/module/sysm/SysQueryMgr.vue"),

};

export default Object.assign(base, log, usrm, sysm);